import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Range } from '@zapsa/zap-redux-forms-components';
import AnimatedNumber from 'react-animated-number';
import ZapIcon from '@zapsa/zap-icons';

const validate = () => {
  const errors = {};

  return errors;
};

class PriceCalculatorView extends Component {
  static propTypes = {
    quantity: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    quantity: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.ranges = [
      { end: 25, price: 6 },
      { end: 50, price: 5.5 },
      { end: 100, price: 5 },
      { end: 200, price: 4.5 },
      { end: 500, price: 4 },
      { end: 1000, price: 3.5 },
    ];
    this.lowestPrice = 3;

    this.calculatePrice = ::this.calculatePrice;
  }

  calculatePrice() {
    if (this.props.quantity) {
      let total = 0;
      let prevKey = 0;
      let leftToBill = parseInt(this.props.quantity, 10);
      this.ranges.forEach((elem, index) => {
        if (parseInt(this.props.quantity, 10) >= elem.end) {
          if (this.ranges.length - 1 === index) {
            total += (parseInt(this.props.quantity, 10) - (elem.end + 1)) * this.lowestPrice;
          }
          total += elem.price * (elem.end - (prevKey === 0 ? 0 : prevKey + 1));
        } else if (leftToBill > 0) {
          total += (leftToBill - 1) * elem.price;
        }
        leftToBill -= (elem.end - prevKey);
        prevKey = elem.end;
      });
      return total;
    }
  }

  render() {
    const price = this.calculatePrice();
    return (
      <form onSubmit={this.props.handleSubmit}>
        <h2>{this.props.translations['pricing.simulation']}</h2>
        <div className="u-flex u-flex-align-items">
          <Field
            component={Range}
            name="quantity"
            label={this.props.translations['pricing.userQuantity']}
            max="1500"
            min="5"
            step="5"
          />
          <div className="label u-ml-4">
            {this.props.quantity}
          </div>
        </div>
        {price
        && (
        <table className="pricing-table">
          <tr className="u-flex">
            <th>Total</th>
            <td className="label label--blueLight label-xl u-flex" style={{ alignSelf: 'center' }}>
              <AnimatedNumber
                component="text"
                value={price}
                style={{
                  transition: '0.8s ease-out',
                }}
                duration={500}
                stepPrecision={0}
              />
              ‎{this.props.translations['pricing.euroPerMonth']}
            </td>
          </tr>
        </table>
        )
    }
        <h3>{this.props.translations['pricing.ourPricingModel']}</h3>
        <div className="alert alert--info-accent u-mt-2">{this.props.translations['pricing.ourPricingModelDesc']}</div>
        <div style={{ display: 'flex', gap: '10px', overflow: 'scroll', padding: '4px' }} className="u-mt-2 u-mb-2">
          {this.ranges.map((range, index) => (
            <div className="box" style={{ flex: '1 1 0px', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <ZapIcon icon="userGroups--lines" />
              <div className="text-caption" style={{ fontStyle: 'italic' }}>{(this.ranges[index - 1] ? this.ranges[index - 1].end + 1 : 0)} - {range.end}</div>
              <div className="u-mt-4 text-bodyBold">
                {range.price}‎€
              </div>
              <div className="text-caption">{this.props.translations['pricing.perUserPerMonth']}</div>
            </div>
          ))}
          <div className="box" style={{ flex: '1 1 0px', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <ZapIcon icon="userGroups--lines" />
            <div className="text-caption" style={{ fontStyle: 'italic' }}>{`> ${this.ranges[this.ranges.length - 1].end + 1}`}</div>
            <div className="u-mt-4 text-bodyBold">
              {this.lowestPrice}‎€
            </div>
            <div className="text-caption">{this.props.translations['pricing.perUserPerMonth']}</div>
          </div>
        </div>
      </form>
    );
  }
}

const PriceCalculatorContainer = reduxForm({
  form: 'priceCalculatorForm',
  validate,
  initialValues: {
    quantity: '200',
  },
})(PriceCalculatorView);

const selector = formValueSelector('priceCalculatorForm');

const PriceCalculator = connect(
  state => ({
    quantity: selector(state, 'quantity'),
    translations: state.i18n.translations[state.i18n.lang],
  }),
  dispatch =>
    bindActionCreators(
      {
      },
      dispatch,
    ),
)(PriceCalculatorContainer);

export default PriceCalculator;
